<template>
	<div class="login-container">
		<div class="login-left">
			<div class="logo">
				<img src="https://filelsjc.tt65org.com/uploads/20260203/11d4e1a93ec5fc496e0f3af18b1bb2b5.png" alt="Logo" />
				<span>与绿同行</span>
			</div>
			<div class="illustration">
				<img src="https://filelsjc.tt65org.com/uploads/20260123/7ae10c30c4779acb7d27c6c45ffd7580.png" alt="Illustration" />
			</div>
		</div>
		<div class="login-right">
			<div class="login-box">
				<h2 class="welcome-title">湖北高校“与绿同行”项目申报</h2>
				<p class="welcome-subtitle">请选择您的角色并输入账户信息</p>

				<div class="role-tabs">
					<el-button :type="currentRole === '1' ? 'primary' : ''" @click="getCurrentRole('1')">
						<i class="el-icon-s-home"></i> 项目申报
					</el-button>
					<el-button :type="currentRole === '2' ? 'primary' : ''" @click="getCurrentRole('2')">
						<i class="el-icon-user"></i> 项目评审
					</el-button>
				</div>
				<el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
					<el-form-item v-if="currentRole == 1">
						<el-radio-group v-model="loginForm.chooseType" @change="handleChooseTypeChange">
							<el-radio :label="2">手机号+验证码</el-radio>
							<el-radio :label="1">手机号+密码</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item prop="mobile">
						<el-input v-model="loginForm.mobile" :placeholder="currentRole==1?'请输入手机号':'请输入账号'" prefix-icon="el-icon-user"></el-input>
					</el-form-item>

					<el-form-item prop="password" v-if="currentRole == 2||loginForm.chooseType == 1">
						<el-input type="password" v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
					</el-form-item>
					<!-- <el-form-item prop="password" v-if="currentRole == 2">
						<el-input type="password" v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
					</el-form-item> -->
					
					<!-- 1需要验证码 -->
					<el-form-item v-if="currentRole == '1'&&loginForm.chooseType == 2" prop="code">
						<div class="code-input-group">
							<el-input v-model="loginForm.code" placeholder="请输入验证码" maxlength="6" prefix-icon="el-icon-message"></el-input>
							<el-button :disabled="countdown > 0" @click="sendCode" class="code-btn">
								{{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}
							</el-button>
						</div>
					</el-form-item>

					<el-form-item v-if="currentRole == 2">
						<el-button type="primary" @click="handleLogin" :loading="loading" class="login-btn">
							项目评审登录
						</el-button>
					</el-form-item>
					<el-form-item v-if="currentRole == 1">
						<el-button type="primary" @click="handleLogin" :loading="loading" class="login-btn">
							项目申报登录
						</el-button>
					</el-form-item>
				</el-form>
				<div class="tiptext" v-if="currentRole == 1">小程序用户可登录网页端进行申报</div>
				<div class="qr-container" v-if="currentRole == 1">
					<img src="@/assets/qrimg.jpg" class="qr-img" />
					<div class="qr-tip">如果未收到验证码，请扫码进入小程序，设置登录密码后，使用手机号+密码登录。</div>
				</div>
				<!-- <div class="zhuce" @click="goRegister">立即注册</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import {loginbyweb,getptip,sendSms,AdminLogin} from "@/api/signUp.js"
export default {
	name: 'Login',
	data() {
		// 用户名验证
		const validateUsername = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入用户名'));
			} else {
				callback();
			}
		};
		// 密码验证
		const validatePassword = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入密码'));
			} else {
				callback();
			}
		};
		// 验证码验证
		const validateCode = (rule, value, callback) => {
			if (this.currentRole === '1') {
				if (!value) {
					callback(new Error('请输入验证码'));
				}else {
					callback();
				}
			} else {
				callback();
			}
		};

		return {
			currentRole: '1',
			loginForm: {
				mobile: '',
				password: '',
				code: '',
				chooseType:2
			},
			rules: {
				mobile: [
					{ validator: validateUsername, trigger: 'blur' }
				],
				password: [
					{ validator: validatePassword, trigger: 'blur' }
				],
				code: [
					{ validator: validateCode, trigger: 'blur' }
				]
			},
			loading: false,
			countdown: 0,
			timer: null
		};
	},
	methods: {
		// 发送验证码
		sendCode() {
			if(!this.loginForm.mobile) {
				this.$message.error('请输入手机号');
				return;
			}
			if (this.countdown > 0) return;
			sendSms({
				mobile: this.loginForm.mobile,
				event: 'mobilelogin'
			}).then(res => {
				console.log(res);
			})
			// 模拟发送验证码
			this.$message.success('验证码已发送');
			this.startCountdown();
		},
		// 开始倒计时
		startCountdown() {
			this.countdown = 60;
			this.timer = setInterval(() => {
				this.countdown--;
				if (this.countdown <= 0) {
					clearInterval(this.timer);
					this.timer = null;
				}
			}, 1000);
		},
		// 登录
		handleLogin() {
			this.$refs.loginForm.validate((valid) => {
				if (valid) {
					if(this.currentRole == 1) {
						loginbyweb({
							mobile: this.loginForm.mobile,
							captcha: this.loginForm.code,
							password: this.loginForm.password
						}).then(res => {
							if(res.data.code == 1){
								this.$message.success(res.data.msg);
								localStorage.setItem('token', res.data.data.userinfo.token);
								localStorage.setItem('userInfo', JSON.stringify(res.data.data.userinfo));
								setTimeout(() => {
									this.$router.push({
										name: "rich"
									});
								}, 1000);
							}else{
								this.$message.error(res.data.msg);
							}
						})
					} else {
						AdminLogin({
							username: this.loginForm.mobile,
							password: this.loginForm.password
						}).then(res => {
							if(res.data.code == 1){
								localStorage.setItem('token', res.data.data.token);
								localStorage.setItem('userInfo', JSON.stringify(res.data.data));
								setTimeout(() => {
									this.$router.push({
										name: "xiangmu",
										query: {
											admin_id: res.data.data.id
										}
									});
								}, 1000);
							}else{
								this.$message.error(res.data.msg);
							}
						})
					}
				}
			});
		},
		//切换登录模式
		getCurrentRole(role) {
			this.loginForm.mobile = '';
			this.loginForm.password = '';
			this.loginForm.code = '';
			this.currentRole = role;
		},
		//切换登录方式
		handleChooseTypeChange() {
			this.loginForm.password = '';
			this.loginForm.code = '';
		},
		// 去注册
		goRegister() {
			this.$router.push({
				name: "register"
			});
		}
	},
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
		}
	}
};
</script>

<style>
body {
	margin: 0;
}
</style>

<style scoped>
.login-container {
	display: flex;
	height: 100vh;
	overflow: hidden;
}

.login-left {
	flex: 1;
	background: linear-gradient(135deg, #289c52 0%, #289c52 100%);
	color: white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 60px 40px;
	position: relative;
}

.logo {
	display: flex;
	align-items: center;
	gap: 12px;
	position: absolute;
	top: 40px;
	left: 40px;
	font-size: 20px;
	font-weight: bold;
}

.logo img {
	width: 40px;
	height: 40px;
	border-radius: 8px;
}

.illustration {
	margin: 40px 0;
}

.illustration img {
	max-width: 900px;
	height: auto;
	border-radius: 12px;
}

.slogan {
	text-align: center;
	margin: 30px 0;
}

.slogan h3 {
	font-size: 28px;
	margin: 0 0 16px 0;
	font-weight: 600;
}

.slogan p {
	font-size: 16px;
	margin: 0;
	opacity: 0.9;
}

.carousel-dots {
	display: flex;
	gap: 8px;
	margin-top: 40px;
}

.dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.4);
	cursor: pointer;
	transition: all 0.3s;
}

.dot.active {
	background: white;
	width: 24px;
	border-radius: 4px;
}

.login-right {
	flex: 1;
	background: white;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 40px;
}

.login-box {
	width: 100%;
	max-width: 400px;
}

.welcome-title {
	font-size: 26px;
	color: #333;
	margin: 0 0 12px 0;
	font-weight: 600;
}

.welcome-subtitle {
	color: #666;
	margin: 0 0 32px 0;
	font-size: 14px;
}

.role-tabs {
	display: flex;
	gap: 12px;
	margin-bottom: 32px;
	background: #f5f5f5;
	padding: 4px;
	border-radius: 8px;
}

.role-tabs .el-button {
	flex: 1;
	border: none;
	background: transparent;
	color: #666;
	font-weight: 500;
}

.role-tabs .el-button:hover {
	color: #333;
}

.role-tabs .el-button.el-button--primary {
	background: white;
	color: #409eff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tiptext{
	font-size: 14px;
	color: #FF0000;
}

.login-form {
	width: 100%;
}

.code-input-group {
	display: flex;
	gap: 12px;
}

.code-input-group .el-input {
	flex: 1;
}

.code-btn {
	width: 120px;
	height: 40px;
	flex-shrink: 0;
}

.login-btn {
	width: 100%;
	height: 48px;
	font-size: 16px;
	font-weight: 500;
}

.el-form-item {
	margin-bottom: 24px;
}

.el-input {
	height: 48px;
}

.el-input__inner {
	height: 48px;
	line-height: 48px;
	border-radius: 8px;
}
.zhuce{
	margin-top: 20px;
	text-align: center;
	color: #666;
	cursor: pointer;
	text-decoration: underline;
}

.qr-container {
    text-align: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.qr-img {
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
}

.qr-tip {
    font-size: 13px;
    color: #666;
    line-height: 1.6;
    max-width: 300px;
    margin: 0 auto;
}
</style>